"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ng2_stompjs_1 = require("@stomp/ng2-stompjs");
var authentication_service_1 = require("../../shared/service/authentication.service");
var Subject_1 = require("rxjs/Subject");
var coordinate_diagnosis_1 = require("../../shared/model/coordinate-diagnosis");
var equipment_diagnosis_1 = require("../../shared/model/equipment-diagnosis");
var gps_diagnosis_1 = require("../../shared/model/gps-diagnosis");
var gprs_diagnosis_1 = require("../../shared/model/gprs-diagnosis");
var diagnosis_general_result_1 = require("../../shared/model/diagnosis-general-result");
var DiagnosisWebSocketService = /** @class */ (function () {
    function DiagnosisWebSocketService(_webSocket, _authService) {
        this._webSocket = _webSocket;
        this._authService = _authService;
        this.RUN_END_POINT = '/api/diagnosis/run';
        this.SUCCESS_END_POINT = '/diagnosis/success/';
        this.FAIL_END_POINT = '/diagnosis/failed/';
        this.RESPONSE_END_POINT = '/diagnosis/response/';
        this.RUNNING_END_POINT = '/diagnosis/running/';
        this.TIMEOUT_END_POINT = '/diagnosis/timeout/';
        this.ERROR_END_POINT = '/diagnosis/error/';
        this.successSubscription = null;
        this.failedSubscription = null;
        this.responseSubscription = null;
        this.runningSubscription = null;
        this.timeoutSubscription = null;
        this.errorSubscription = null;
        this.userHashCode = this.getUserHashCode();
        this.successSubject = new Subject_1.Subject();
        this.success$ = this.successSubject.asObservable();
        this.failedSubject = new Subject_1.Subject();
        this.failed$ = this.failedSubject.asObservable();
        this.responseSubject = new Subject_1.Subject();
        this.response$ = this.responseSubject.asObservable();
        this.restartSubject = new Subject_1.Subject();
        this.restart$ = this.restartSubject.asObservable();
        this.vehicleSubject = new Subject_1.Subject();
        this.vehicle$ = this.vehicleSubject.asObservable();
        this.runningSubject = new Subject_1.Subject();
        this.running$ = this.runningSubject.asObservable();
        this.timeoutSubject = new Subject_1.Subject();
        this.timeout$ = this.timeoutSubject.asObservable();
        this.backSubject = new Subject_1.Subject();
        this.back$ = this.backSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
        this.getWebSocketSubscriptions();
    }
    DiagnosisWebSocketService.prototype.run = function (vehicle) {
        if (this.customer) {
            this.setVehicle(vehicle);
            this.notifyVehicleIsAvailable();
            this.subscribeSuccess();
            this.subscribeFailed();
            this.subscribeResponse();
            this.subscribeRunning();
            this.subscribeTimeout();
            this.subscribeError();
            this._webSocket.publish(this.RUN_END_POINT, JSON.stringify(this.vehicle));
        }
        else {
            throw new Error();
        }
    };
    DiagnosisWebSocketService.prototype.restart = function () {
        this.restartSubject.next();
        this.notifyVehicleIsAvailable();
        this._webSocket.publish(this.RUN_END_POINT, JSON.stringify(this.vehicle));
    };
    DiagnosisWebSocketService.prototype.back = function () {
        this.backSubject.next();
    };
    DiagnosisWebSocketService.prototype.setCustomer = function (customer) {
        this.customer = customer;
    };
    DiagnosisWebSocketService.prototype.getCustomer = function () {
        return this.customer;
    };
    DiagnosisWebSocketService.prototype.setVehicle = function (vehicle) {
        vehicle.userHashCode = this.userHashCode;
        vehicle.customerName = this.customer.name;
        vehicle.trixUserId = this.customer.trixUser.id;
        this.vehicle = vehicle;
    };
    DiagnosisWebSocketService.prototype.notifyVehicleIsAvailable = function () {
        if (this.vehicle) {
            this.vehicleSubject.next(this.vehicle);
        }
    };
    DiagnosisWebSocketService.prototype.getVehicle = function () {
        return this.vehicle;
    };
    DiagnosisWebSocketService.prototype.getUserHashCode = function () {
        return this._authService.getUserFromLocalStorage().userHashCode;
    };
    DiagnosisWebSocketService.prototype.parseResult = function (result) {
        result = JSON.parse(result);
        return Object.assign(this.getDiagnosisResultInstance(result), result);
    };
    DiagnosisWebSocketService.prototype.getDiagnosisResultInstance = function (result) {
        switch (result.type) {
            case 'EQUIPMENT': return new equipment_diagnosis_1.EquipmentDiagnosis();
            case 'COORDINATE': return new coordinate_diagnosis_1.CoordinateDiagnosis();
            case 'GPS': return new gps_diagnosis_1.GpsDiagnosis();
            case 'GPRS': return new gprs_diagnosis_1.GprsDiagnosis();
            default: return {};
        }
    };
    DiagnosisWebSocketService.prototype.getWebSocketSubscriptions = function () {
        this.successSubscription =
            this._webSocket.subscribe("" + this.SUCCESS_END_POINT + this.userHashCode);
        this.failedSubscription =
            this._webSocket.subscribe("" + this.FAIL_END_POINT + this.userHashCode);
        this.responseSubscription =
            this._webSocket.subscribe("" + this.RESPONSE_END_POINT + this.userHashCode);
        this.runningSubscription =
            this._webSocket.subscribe("" + this.RUNNING_END_POINT + this.userHashCode);
        this.timeoutSubscription =
            this._webSocket.subscribe("" + this.TIMEOUT_END_POINT + this.userHashCode);
        this.errorSubscription =
            this._webSocket.subscribe("" + this.ERROR_END_POINT + this.userHashCode);
    };
    DiagnosisWebSocketService.prototype.subscribeSuccess = function () {
        var _this = this;
        this.successSubscription
            .map(function (message) {
            return _this.parseResult(message.body);
        })
            .subscribe(function (message) { return _this.successSubject.next(message); });
    };
    DiagnosisWebSocketService.prototype.subscribeFailed = function () {
        var _this = this;
        this.failedSubscription
            .map(function (message) {
            return _this.parseResult(message.body);
        })
            .subscribe(function (message) { return _this.failedSubject.next(message); });
    };
    DiagnosisWebSocketService.prototype.subscribeResponse = function () {
        var _this = this;
        this.responseSubscription
            .map(function (message) {
            var result = JSON.parse(message.body);
            if (Array.isArray(result)) {
                return Object.assign(new Array(), result);
            }
            else {
                return Object.assign(new diagnosis_general_result_1.DiagnosisGeneralResult(), result);
            }
        })
            .subscribe(function (message) { return _this.responseSubject.next(message); });
    };
    DiagnosisWebSocketService.prototype.subscribeRunning = function () {
        var _this = this;
        this.runningSubscription
            .map(function (message) {
            return _this.parseResult(message.body);
        })
            .subscribe(function (message) { return _this.runningSubject.next(message); });
    };
    DiagnosisWebSocketService.prototype.subscribeTimeout = function () {
        var _this = this;
        this.timeoutSubscription
            .map(function (message) {
            return _this.parseResult(message.body);
        })
            .subscribe(function (message) { return _this.timeoutSubject.next(message); });
    };
    DiagnosisWebSocketService.prototype.subscribeError = function () {
        var _this = this;
        this.errorSubscription
            .map(function (message) {
            return _this.parseResult(message.body);
        })
            .subscribe(function (message) { return _this.errorSubject.next(message); });
    };
    DiagnosisWebSocketService.ctorParameters = function () { return [{ type: ng2_stompjs_1.StompService }, { type: authentication_service_1.AuthenticationService }]; };
    return DiagnosisWebSocketService;
}());
exports.DiagnosisWebSocketService = DiagnosisWebSocketService;
//# sourceMappingURL=diagnosis-web-socket.service.js.map


// WEBPACK FOOTER //
// diagnosis-web-socket.service.js